import { FeedbackApi } from '@/api';
import { Module } from 'vuex';
import { Actions } from './actions';
import { RootState } from './root.store';

const feedbackApi = new FeedbackApi();

export const FeedbackModule: Module<any, RootState> = {
  actions: {
    async [Actions.feedback.post](_, feedback: { content: string }): Promise<void> {
      return await feedbackApi.postFeedback(feedback);
    },
  },
};
